export interface RefundPayload {
    withdrawal_id: string;
    deposit_id: string;
    user: string;
    amount: number;
}
